import request from '../helpers/request';

const getWarrantyDocsFile = async (docId) => {
  const res = await request.get(
    `/Warranty/docs/file/${docId}`,
    {},
    'Не удалось загрузить файл'
  );

  return res;
};

export default getWarrantyDocsFile;
